import {lazy} from "react";

export const GroupedCoursePageAsync = lazy(async () => import('./GroupedCoursePage'));
